module.exports = __webpack_public_path__ + "img/user-dashboard.afb3ad5a.svg";